import Vue from 'vue';
import Vuex from 'vuex';
import livesData from './modules/lives-data.js';
import commonData from './modules/common-data.js';
import formData from './modules/form-data.js';
import socketData from './modules/lives-socket.js';

Vue.use(Vuex);

const debug =window.process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    lives: livesData,
    common: commonData,
    form: formData,
    socket:socketData,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js